import SherryLogo from '@/components/generated/SherryLogo';
import React from 'react';

interface SherryLogoParserProps {
  text: string;
}
export const sherryLogoParser = ({ text }: SherryLogoParserProps) =>
  text.split('Sherry').map((splitText, index) => (
    <React.Fragment key={splitText}>
      {splitText}
      {index !== text.split('Sherry').length - 1 && <SherryLogo />}
    </React.Fragment>
  ));
